module.exports = __webpack_public_path__ + "static/media/Ø1_3.947874df.png";